import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { TrendingDown, FileCheck, Users, CheckCircle2 } from "lucide-react";

const DebtRelief = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-4">
        <div className="container mx-auto max-w-4xl text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
            מחיקת חובות
          </h1>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            פתרונות משפטיים למחיקת חובות והקלה כלכלית, ליווי מקצועי בהליכי הסדר חובות ופשיטת רגל
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 px-4 bg-muted/30">
        <div className="container mx-auto max-w-6xl">
          <h2 className="text-3xl font-bold text-center mb-12">השירותים שלנו</h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-background p-8 rounded-lg border border-border hover:shadow-lg transition-shadow">
              <TrendingDown className="w-12 h-12 text-foreground mb-4" />
              <h3 className="text-xl font-semibold mb-3">הסדר חובות</h3>
              <p className="text-muted-foreground">
                ניהול הליכי הסדר חובות מול נושים, מיזעור תשלומים והגעה להסדרים מיטביים המותאמים ליכולת הכלכלית
              </p>
            </div>

            <div className="bg-background p-8 rounded-lg border border-border hover:shadow-lg transition-shadow">
              <FileCheck className="w-12 h-12 text-foreground mb-4" />
              <h3 className="text-xl font-semibold mb-3">פשיטת רגל</h3>
              <p className="text-muted-foreground">
                הגשת בקשות לפשיטת רגל, ליווי מלא בהליכים המשפטיים ומחיקת חובות בהתאם לחוק
              </p>
            </div>

            <div className="bg-background p-8 rounded-lg border border-border hover:shadow-lg transition-shadow">
              <Users className="w-12 h-12 text-foreground mb-4" />
              <h3 className="text-xl font-semibold mb-3">משא ומתן עם נושים</h3>
              <p className="text-muted-foreground">
                ייצוג בפני נושים, ניהול משא ומתן מקצועי והשגת תנאים מיטביים להקלה כלכלית
              </p>
            </div>

            <div className="bg-background p-8 rounded-lg border border-border hover:shadow-lg transition-shadow">
              <CheckCircle2 className="w-12 h-12 text-foreground mb-4" />
              <h3 className="text-xl font-semibold mb-3">הקלה כלכלית</h3>
              <p className="text-muted-foreground">
                פתרונות משפטיים להקלה בנטל הכלכלי, הגנה מפני הליכי גבייה ושמירה על רכוש החייב
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4">
        <div className="container mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold mb-6">זקוקים לסיוע במחיקת חובות?</h2>
          <p className="text-lg text-muted-foreground mb-8">
            פנו אלינו לייעוץ מקצועי ובדיקת האפשרויות העומדות בפניכם
          </p>
          <Link to="/contact">
            <Button size="lg" className="text-lg px-8">
              צור קשר
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default DebtRelief;